import apiClient from './client'

export const couponsApi = {
  validateCoupon: async (data) => {
    const response = await apiClient.post('/coupons/validate', data)
    return response.data
  },

  redeemCoupon: async (data) => {
    const response = await apiClient.post('/coupons/redeem', data)
    return response.data
  },
}

